"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThemeType = void 0;
var ThemeType;
(function (ThemeType) {
    ThemeType["Dark"] = "dark";
    ThemeType["Light"] = "light";
})(ThemeType = exports.ThemeType || (exports.ThemeType = {}));
